import { Col, Row } from "antd";
import { get } from "lodash";
import { useTranslation } from "react-i18next";
import { MdOutlineFileUpload } from "react-icons/md";
import Button from "shared/components/Button";
import Form from "shared/components/Form";
import Input from "shared/components/Input";
import Label from "shared/components/Label";
import { NAME_SPACES } from "shared/locales/constants";
import { ATTACHMENT_TYPES, FAMILY_SITUATION } from "utils/constants";

const Spouse = ({
  values,
  onFileRemove,
  setFieldValue,
  setPercent,
  disabled,
  subscription,
}) => {
  const { t } = useTranslation(NAME_SPACES.PRIVATE.BROKER.CONTRACT);
  const SUBSCRIPTION = t("SUBSCRIPTION", { returnObjects: true });
  const isNotMarried =
    get(subscription, "project.contact.fields.familySituation") !==
    FAMILY_SITUATION.MARRIED;

  return (
    <div className="subscription-form--wrapper">
      <Form type="vertical" title={SUBSCRIPTION.FORM.PROOF.SPOUSE}>
        <Row gutter={[16, 16]}>
          <Col lg={24} xs={24}>
            <div className="subscription-form--group-label">
              <Label
                label={
                  SUBSCRIPTION.FORM.PROOF.MUTUAL_MOBILITY
                    .HEALTH_INSURANCE_RIGHTS_CERTIFICATE
                }
                icon={<MdOutlineFileUpload size={16} />}
                required
              />
            </div>
          </Col>
          <Col lg={24} xs={24}>
            <div className="subscription-form--custom-upload">
              <Input
                type="file"
                variant="uploader"
                validTypes={SUBSCRIPTION.FORM.PROOF.ALLOWED_FILES_TYPE}
                onUpload={(fileList) => {
                  setFieldValue(
                    `proof.spouse.${ATTACHMENT_TYPES.SOCIAL_SECURITY_CERTIFICATE}`,
                    fileList,
                  );
                  setPercent({
                    ...values,
                    proof: {
                      ...values.proof,
                      spouse: {
                        ...get(values, "proof.spouse"),
                        [ATTACHMENT_TYPES.SOCIAL_SECURITY_CERTIFICATE]:
                          fileList,
                      },
                    },
                  });
                }}
                onFileRemove={onFileRemove}
                fileList={get(
                  values,
                  `proof.spouse.${ATTACHMENT_TYPES.SOCIAL_SECURITY_CERTIFICATE}`,
                  [],
                )}
              >
                <Row align="center">
                  <Button type="primary--link">
                    {SUBSCRIPTION.FORM.PROOF.ACTION.ADD}
                  </Button>
                </Row>
              </Input>
            </div>
          </Col>
        </Row>
        {isNotMarried && (
          <Row gutter={[16, 16]}>
            <Col lg={24} xs={24}>
              <div className="subscription-form--group-label">
                <Label
                  label={SUBSCRIPTION.FORM.PROOF.MUTUAL_MOBILITY.ELIGIBILITY}
                  icon={<MdOutlineFileUpload size={16} />}
                  required
                />
              </div>
            </Col>
            <Col lg={24} xs={24}>
              <div className="subscription-form--custom-upload">
                <Input
                  type="file"
                  variant="uploader"
                  validTypes={SUBSCRIPTION.FORM.PROOF.ALLOWED_FILES_TYPE}
                  onUpload={(fileList) => {
                    setFieldValue(
                      `proof.spouse.${ATTACHMENT_TYPES.MARITAL_CERTIFICATE}`,
                      fileList,
                    );
                    setPercent({
                      ...values,
                      proof: {
                        ...values.proof,
                        spouse: {
                          ...get(values, "proof.spouse"),
                          [ATTACHMENT_TYPES.MARITAL_CERTIFICATE]: fileList,
                        },
                      },
                    });
                  }}
                  onFileRemove={onFileRemove}
                  fileList={get(
                    values,
                    `proof.spouse.${ATTACHMENT_TYPES.MARITAL_CERTIFICATE}`,
                    [],
                  )}
                >
                  <Row align="center">
                    <Button type="primary--link">
                      {SUBSCRIPTION.FORM.PROOF.ACTION.ADD}
                    </Button>
                  </Row>
                </Input>
              </div>
            </Col>
          </Row>
        )}
      </Form>
    </div>
  );
};

export default Spouse;
